var render = function render(){var _vm=this,_c=_vm._self._c;return _c('amplify-forgot-password',{attrs:{"slot":"forgot-password","header-text":"Confirmação de Mudança de Senha","username-alias":"email"},slot:"forgot-password"})
}
var staticRenderFns = []

export { render, staticRenderFns }